
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

interface DurationInputProps {
  defaultValue?: number;
}

export const DurationInput = ({ defaultValue }: DurationInputProps) => {
  const { control, setValue, watch } = useFormContext();
  const planName = watch('name');
  
  // Update duration when plan type changes or defaultValue is provided
  useEffect(() => {
    if (planName === 'Monthly') {
      setValue('duration', 30);
    } else if (planName === 'Yearly') {
      setValue('duration', 365);
    } else if (planName === 'Free Trial' && defaultValue) {
      setValue('duration', defaultValue);
    }
  }, [planName, setValue, defaultValue]);

  return (
    <FormField
      control={control}
      name="duration"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Duration (days)</FormLabel>
          <FormControl>
            <Input
              type="number"
              placeholder="30"
              {...field}
              onChange={(e) => field.onChange(parseInt(e.target.value) || 30)}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
